import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {KeycloakAuthGuard, KeycloakService} from 'keycloak-angular';
import {ROOT_SECURED, WELCOME} from '@core/services/routes.service';
import {EnvironmentService} from '@core/environment/environment.service';

@Injectable({
    providedIn: 'root',
})
export class RoleRedirectGuard extends KeycloakAuthGuard {
    constructor(protected readonly router: Router, protected readonly keycloak: KeycloakService,
                protected readonly environment: EnvironmentService) {
        super(router, keycloak);
    }

    public async isAccessAllowed(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        if (!this.authenticated) {
            const location = window.location.href.indexOf('/public') > 0 ? window.location.origin + '/#' + ROOT_SECURED : window.location.href;
            await this.keycloak.login({
                locale: localStorage.getItem('languageCode'),
                redirectUri: location
            });
        }

        await this.router.navigate([WELCOME]);

        return true;
    }
}
